(() => {
  const button = document.querySelector('.spirit-floating-whatsapp');
  if (!button) return;

  const mobile = window.matchMedia('(max-width: 749px)');
  let bars = [];
  let frame;

  const sync = () => {
    frame = null;
    let offset = 0;
    if (mobile.matches) {
      bars.forEach((bar) => {
        const style = getComputedStyle(bar);
        const rect = bar.getBoundingClientRect();
        if (style.position !== 'fixed' || style.visibility === 'hidden' || style.display === 'none' || !rect.height) return;
        offset = Math.max(offset, window.innerHeight - rect.top);
      });
    }
    button.style.setProperty('--spirit-whatsapp-purchase-offset', `${Math.ceil(offset)}px`);
  };

  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(sync);
  };
  const sizes = new ResizeObserver(schedule);
  const visibility = new MutationObserver(schedule);
  const observeBars = () => {
    sizes.disconnect();
    visibility.disconnect();
    bars = Array.from(document.querySelectorAll('.spirit-event-purchase, .spirit-product-sticky-bar'));
    bars.forEach((bar) => {
      sizes.observe(bar);
      visibility.observe(bar, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
    });
    schedule();
  };

  mobile.addEventListener('change', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', observeBars);
  document.addEventListener('shopify:section:load', observeBars);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(observeBars));
  observeBars();
})();
